module.exports = __webpack_public_path__ + "img/btn_my_record_off.cb7b2fe0.png";